export const UTILITY_KIND = {
	WATER: "water",
	GAS: "gas",
	ELECTRICITY: "electricity",
} as const;

export type UtilityKind = (typeof UTILITY_KIND)[keyof typeof UTILITY_KIND];
